const onlineBankingCCBStore = () => {
  const solution = ref('');

  const solutionUpdate = (data) => {
    solution.value = data;
  };

  const solutionReset = () => {
    solution.value = '';
  };

  return {
    solution,
    solutionUpdate,
    solutionReset,
  };
};

export const useOnlineBankingCCBStore = defineStore(
  'onlineBankingCCBStore',
  onlineBankingCCBStore,
  {
    persist: {
      enabled: true,
      storage: sessionStorage,
    },
  }
);
